module.exports = __webpack_public_path__ + "img/circular.271b54e7.png";